import React from 'react';
import { connect } from 'react-redux';
import CreatableSelect from 'react-select/creatable';

// Actions
import { setUserData } from '../../actions/stepsUser';

const SelectPersonalized = (props) => {
    
    // Actions
    const { setUserData } = props;

    // States
    const { position } = props;

    // External props
    const { options, canCreate, createString } = props;

    const handleChange = ( newValue ) => {
        if ( newValue.label !== null ) {
            setUserData({
                position: newValue
            })
        }
    };

    return (
        <CreatableSelect
            theme={(theme) => ({
                ...theme,
                borderRadius: 6,
                colors: {
                    ...theme.colors,
                    primary25: "#E4F7EC",
                    primary: "#0DA15A"
                }
            })}
            styles={{
                control: (base, state) => ({
                    ...base,
                    backgroundColor: 'var(--card)',
                    borderColor: state.isFocused ? 'var(--primary)' : 'var(--border)',
                    boxShadow: 'none',
                    ':hover': { borderColor: 'var(--border-strong)' },
                }),
                menu: (base) => ({
                    ...base,
                    backgroundColor: 'var(--card)',
                    border: '1px solid var(--border)',
                    zIndex: 20,
                }),
                option: (base, state) => ({
                    ...base,
                    backgroundColor: state.isSelected
                        ? 'var(--primary-tint)'
                        : state.isFocused
                            ? 'var(--secondary)'
                            : 'transparent',
                    color: 'var(--foreground)',
                    ':active': { backgroundColor: 'var(--primary-tint)' },
                }),
                singleValue: (base) => ({ ...base, color: 'var(--foreground)' }),
                input: (base) => ({ ...base, color: 'var(--foreground)' }),
                placeholder: (base) => ({ ...base, color: 'var(--muted-foreground)' }),
                dropdownIndicator: (base) => ({
                    ...base,
                    color: 'var(--muted-foreground)',
                    ':hover': { color: 'var(--foreground)' },
                }),
                clearIndicator: (base) => ({
                    ...base,
                    color: 'var(--muted-foreground)',
                    ':hover': { color: 'var(--foreground)' },
                }),
                indicatorSeparator: (base) => ({ ...base, backgroundColor: 'var(--border)' }),
                multiValue: (base) => ({ ...base, backgroundColor: 'var(--secondary)' }),
                multiValueLabel: (base) => ({ ...base, color: 'var(--foreground)' }),
            }}
            placeholder='Seleccionar...'
            isClearable
            onChange={ handleChange }
            value={ position }
            options={ options }
            isValidNewOption={(e)=>{
                if ( !canCreate ) return false
                if (e === "" || e === " ") return false
                if (typeof e === 'string') {
                    return true
                } else {
                    return false
                }
            }}
            formatCreateLabel={(e)=>{
                return `${createString}: "${e}"`
            }}
            className={'CreatableSelect'}
        />
    );

}

const mapStateToProps = state => {
    return {
        position: state.stepsUser.userData.position,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setUserData: (value) => dispatch(setUserData(value)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectPersonalized);